// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import TerceraRenameScreenTemplate from '@front/templates/TerceraRenameScreenTemplate.html';
import TerceraRenameScreenFooterTemplate from '@front/templates/TerceraRenameScreenFooterTemplate.html';
import { MessageBoxType } from '@shared/utils/MessageBoxUtils';
import { TerceraMessageBox } from './TerceraMessageBox';
import { TerceraWindowBase } from './TerceraWindowBase';
import { ScreensNames } from '../UtilsClasses/FactoryConstants';
export class TerceraRenameScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    getType() {
        return ScreensNames.RenameScreen;
    }
    oncomplete() {
        super.oncomplete();
        void this.set({
            okBtnText: Resources.getResource('screen.renameScreen.ok'),
            cancelBtnText: Resources.getResource('screen.renameScreen.cancel')
        });
        this.Controls.textBox.setFocus();
    }
    onOKBtnClicked() {
        const newName = this.get('currentName');
        if (!newName) {
            TerceraMessageBox.Show(Resources.getResource('screen.error.title'), Resources.getResource('screen.renameScreen.illegalName'), MessageBoxType.Info, null, null, false, true, '');
        }
        else if (this.callBack) {
            this.callBack(newName);
            this.close();
        }
    }
    onCanceBtnlClick() {
        this.close();
    }
    static show(currentName, callBack, header) {
        const scr = new TerceraRenameScreen();
        void scr.set('name', 'renameScreen');
        void scr.set('header', header);
        void scr.set('currentName', currentName);
        scr.callBack = callBack;
        MainWindowManager.AddControl(scr);
        scr.center();
    }
}
TerceraWindowBase.extendWith(TerceraRenameScreen, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            resizable: false,
            width: 300,
            height: 168,
            currentName: '',
            style_addition_body: 'tercera-rename-innerContainer'
        };
    },
    partials: {
        bodyPartial: TerceraRenameScreenTemplate,
        footerPartial: TerceraRenameScreenFooterTemplate
    }
});
